import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "apis/types/auth";

interface IAuthState {
  token?: string | null;
  userData?: User | null;
  isNew?: boolean | null;
}
const initialState: IAuthState = {
  token: localStorage.getItem("token") || null,
  userData: null,
  isNew: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<string>) => ({
      ...state,
      token: action.payload,
    }),
    setUserInfo: (state, action: PayloadAction<User>) => ({
      ...state,
      userData: action.payload,
    }),
    logout: () => ({
      token: null,
      userData: null,
    }),
    setIsNewUser: (state, action: PayloadAction<boolean>) => ({
      ...state,
      isNew: action.payload,
    }),
  },
});

// Action creators are generated for each case reducer function
export const { login, setUserInfo, logout, setIsNewUser } = authSlice.actions;

export default authSlice.reducer;
